/**
 * featureFlagsPlugin：Vue3 插件，提供 $hasFeature 全局方法
 *
 * 模板中使用：v-if="$hasFeature('Login-ForgotPassword-Show')"
 * 脚本中使用：import { hasFeature } from '@/diffconfig/featureFlagsPlugin'
 *
 * 开关命名规则同 config/featureFlags.ts：Module-Page-Feature
 */
import type { App } from 'vue'
import appFeatureFlags from '@app/config/featureFlags'
import standardFeatureFlags from './config/featureFlags'
import { validateOverrides } from './validateOverrides'

validateOverrides('featureFlags', standardFeatureFlags, appFeatureFlags)

const store: Record<string, boolean> = { ...standardFeatureFlags, ...appFeatureFlags }

/**
 * hasFeature：判断特性开关是否打开
 * @param key 开关名称（必须在 config/featureFlags.ts 中声明）
 */
export function hasFeature(key: string): boolean {
  if (!(key in store)) {
    console.warn(
      `[featureFlags] unknown key: "${key}", did you forget to declare it in diffconfig/config/featureFlags.ts?`
    )
    return false
  }
  return !!store[key]
}

/**
 * Vue3 插件
 */
const featureFlagsPlugin = {
  install(app: App) {
    app.config.globalProperties.$hasFeature = hasFeature
  }
}

export default featureFlagsPlugin
